export const congeList = {
  leaves: {
    header_title: "Leave Requests List",
    form: {
      title_edit: "View Leave Request",
      type: "Leave Type",
      comment: "Comment",
      justification: "Justification",
      calendar: "Calendar",
      status: "Status",
      createdAt: "Created At",
      download_justif: "Download Justification",
      notAvailable: "Not available",
      updatedAt: "Updated At",
    },

    actions: {
      view: "View",
      validate: "Approved",
    },
  },
  common: {
    valid: "Approved",
    pending: "Pending",
  },
  modal: {
    information: "Leave Request Information",
    details: "Leave Details",
  },
  messages: {
    validated: "The leave request has been validated ✅",
    validate_error: "Error while validating ❌",
  },
};
